import { render } from "./OilPriceLogList.vue?vue&type=template&id=7f833986&scoped=true&ts=true"
import script from "./OilPriceLogList.vue?vue&type=script&lang=ts"
export * from "./OilPriceLogList.vue?vue&type=script&lang=ts"

import "./OilPriceLogList.vue?vue&type=style&index=0&id=7f833986&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f833986"]])

export default __exports__